import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: `${theme.spacing(2)} 0`,
        borderBottom: `1px solid ${theme.palette.border.main}`,
        justifyContent: "center",
    },
    titleContainer: {
        margin: `0 ${theme.spacing(6)}`,
    },
    title: {
        color: theme.palette.primary.dark,
    },
    progressBar: {
        width: "100%",
        display: "flex",
        alignItems: "center",
    },
    downtime: {
        height: 24,
        backgroundColor: theme.palette.error.main,
        borderTopRightRadius: 50,
        borderBottomRightRadius: 50,
    },
    uptime: {
        height: 24,
        backgroundColor: theme.palette.success.main,
        borderTopLeftRadius: 50,
        borderBottomLeftRadius: 50,
        textAlign: "right",
        marginRight: theme.spacing(1),
    },
}));
